import { fetchJson } from './apiClient';

const SELECTED_LOCATION_KEY = 'dealzta:selectedLocationId';

export async function getEnabledLocations() {
  const data = await fetchJson('/locations');
  const locations = Array.isArray(data) ? data : [];
  return locations.filter((location) => location.enabled === true);
}

export function getStoredSelectedLocationId() {
  if (typeof window === 'undefined') return '';
  return window.localStorage.getItem(SELECTED_LOCATION_KEY) || '';
}

export function storeSelectedLocationId(locationId) {
  if (typeof window === 'undefined') return;

  if (locationId) {
    window.localStorage.setItem(SELECTED_LOCATION_KEY, String(locationId));
  } else {
    window.localStorage.removeItem(SELECTED_LOCATION_KEY);
  }
}
